<template>
  <div :style="containerStyle" class="v-rating">
    <template v-for="i in items" :key="i">
      <input
        :disabled="props.static"
        type="radio"
        :id="i.name"
        name="rate"
        :value="i.value"
        @change="radioChanged"
        :checked="i.checked"
      />
      <label :for="i.name" title="text">{{ i.value }} stars</label>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { ICSSProperties, IViewDimension } from "@/stores/types";
const _emit = defineEmits(["update:modelValue", "changed"]);

interface ILocalProps {
  modelValue?: number;
  value: number;
  max: number;
  min: number;
  static: boolean;
  dimension?: IViewDimension;
}

const props = defineProps<ILocalProps>();

interface IRating {
  name: string;
  value: number;
  checked: boolean;
}

const radioChanged = (e: Event) => {
  const _target = e.target as HTMLInputElement;
  _emit("update:modelValue", parseInt(_target.value));
  _emit("changed", parseInt(_target.value));
};

const containerStyle = computed<ICSSProperties>(() => {
  return {
    margin: props.dimension?.margin,
    padding: props.dimension?.padding,
  };
});

const items = computed<IRating[]>(() => {
  const _max = props.max || 5;
  const _min = props.min || 1;
  const _items: IRating[] = [];
  for (let i = _min; i <= _max; i++) {
    _items.push({
      name: `star${i}`,
      value: i,
      checked: props.value ? i === props.value : i === props.modelValue,
    });
  }
  return _items.reverse();
});
</script>

<style>
.v-rating {
  /* float: left; */
  height: 46px;
  /* padding: 0 10px; */
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}
.v-rating:not(:checked) > input {
  position: absolute;
  top: -9999px;
}
.v-rating:not(:checked) > label {
  float: right;
  width: 1em;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  font-size: 30px;
  color: #ccc;
  margin-left: 8px;
  margin-right: 8px;
}
.v-rating:not(:checked) > label:before {
  content: "★ ";
}
.v-rating > input:checked ~ label {
  color: #ffc700;
}
.v-rating:not(:checked) > label:hover,
.v-rating:not(:checked) > label:hover ~ label {
  /* color: #ffc700;   */
}
.v-rating > input:checked + label:hover,
.v-rating > input:checked + label:hover ~ label,
.v-rating > input:checked ~ label:hover,
.v-rating > input:checked ~ label:hover ~ label,
.v-rating > label:hover ~ input:checked ~ label {
  /* color: #ffc700; */
}

/* Modified from: https://github.com/mukulkant/Star-rating-using-pure-css */
</style>
